import { z } from 'my-zod'
import { CompetitiveBrandsUtilizedEnum } from './competitive-brands-utilized'
import { enumOptionsToObject } from '../../internal'

export const competitiveRentalAssetOptions = [
  'ORV',
  'Snow',
  'Marine',
  '3-Wheel',
  'PWC',
  'Motorcycle',
  'Bikes',
  'Segway'
] as const
export const competitiveRentalAssets = enumOptionsToObject(competitiveRentalAssetOptions)
export type CompetitiveRentalAsset = (typeof competitiveRentalAssetOptions)[number]
export const competitiveRentalAssetLabels: Record<CompetitiveRentalAsset, string> = {
  ORV: 'ORV',
  Snow: 'Snow',
  Marine: 'Marine',
  '3-Wheel': '3-Wheel',
  PWC: 'PWC',
  Motorcycle: 'Motorcycle',
  Bikes: 'Bikes',
  Segway: 'Segway'
}

export const CompetitiveRentalAssetsEnum = z.enum(competitiveRentalAssetOptions).setEnumLabels(competitiveRentalAssetLabels)

export const outfitterCompetitiveRentalInventory = z.object({
  outfitterId: z.number(),
  competitiveRentalAsset: CompetitiveRentalAssetsEnum,
  brandUtilized: CompetitiveBrandsUtilizedEnum,
  quantity: z.number().nonnegative()
})

export type outfitterCompetitiveRentalInventory = z.infer<typeof outfitterCompetitiveRentalInventory>
